import { Button } from '@app/components';
import { PricingPlans } from '@app/components/PricingPlans';
import Logo from '@app/assets/horizontal-logo.svg?react';
import { useWelcomeExistingPage } from './WelcomeExisting.hooks';
import { useQuery } from '@tanstack/react-query';
import { getPlans } from '@app/services/plans';
import { WELCOME_FEATURES } from '@app/utils/consts';

export const WelcomeExisting = () => {
  const { 
    navigate, 
    handleChoosePlan, 
    isProcessing, 
    selectedPlan,
    setSelectedPlan
  } = useWelcomeExistingPage();

  // Fetch plans from API
  const { data: plansResponse } = useQuery({
    queryKey: ['get-plans'],
    queryFn: () => getPlans(),
  });

  return (
    <div className="flex items-center justify-center flex-col min-h-screen py-6">
      <Logo width={139} height={110} className="mb-auto" />
      <div className="bg-white text-center space-y-6 rounded max-w-[1200px] px-10 pt-10 pb-6 mb-auto">

        <h2 className="font-bold text-3xl">
          Choose Your Plan
        </h2>
        <p className="text-base-coolGray max-w-2xl mx-auto">
          Select a plan for your new business.
        </p>

        <PricingPlans
          selectedPlan={selectedPlan}
          onPlanTypeSelect={() => {}}
          onPlanSelect={setSelectedPlan}
          showTrialOffer={false}
          plans={plansResponse?.data?.plans}
          buttonText="Select"
        />

        {/* Features Section */}
        <div className="text-center mb-8">
          <h3 className="text-xl font-semibold mb-2 text-brand-baseBlue">What's included in every plan</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {WELCOME_FEATURES.map((feature, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 text-center">
              <div className="flex justify-center mb-4">
                {feature.icon}
              </div>
              <h4 className="font-semibold text-sm mb-2">{feature.title}</h4>
              <p className="text-xs text-base-coolGray">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center gap-4 w-full">
          <Button
            onClick={handleChoosePlan}
            disabled={isProcessing || !selectedPlan}
            loading={isProcessing}
            className="w-full bg-brand-baseBlue text-white font-medium py-3 px-6 rounded-lg"
          >
            Choose Plan
          </Button>

          <button
            onClick={() => navigate('/select-business/create-new')}
            className="w-full bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-lg flex items-center justify-center gap-2"
          >
            <span>←</span>
            Back to Business Setup
          </button>
        </div>
      </div>
    </div>
  );
};
